import App from './module';

export default App;

